// extracted by mini-css-extract-plugin
export default {"mandatory":"CarValuesInput_mandatory__jtnqe","contentLayout":"CarValuesInput_contentLayout__HRdiI","title":"CarValuesInput_title__0+96I"};